import { DS_FILE_FALLBACK_ICON, DS_FILE_TYPE_ICONS } from "@/src/design_system/shared/constants/fileTypeIcons";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import { DS_THUMBNAIL_SIZES, type DSThumbnailSize } from "@/src/design_system/data_display/thumbnail/types";

interface ResolveThumbnailIconOptions {
  fileName?: string;
  size: DSThumbnailSize;
}

const normalizedExtension = (fileName?: string): string => {
  const name = fileName?.trim().split(/[\\/]/).pop() ?? "";
  if (!name.includes(".")) return "";

  return name.slice(name.lastIndexOf(".") + 1).toLowerCase();
};

export const resolveThumbnailIcon = ({ fileName, size }: ResolveThumbnailIconOptions): DSIconName => {
  if (size === DS_THUMBNAIL_SIZES.ExtraSmall) return DS_FILE_FALLBACK_ICON;

  const extension = normalizedExtension(fileName);
  const match = DS_FILE_TYPE_ICONS.find(fileType => fileType.extensions.some(item => item === extension));

  return match?.icon ?? DS_FILE_FALLBACK_ICON;
};
